/* eslint-disable react-hooks/exhaustive-deps */
import classNames from "classnames";
import { ChatDetailContext } from "contexts/chatDetailContext";
import { MessagesContext } from "contexts/messagesContext";
import { ReplyContext } from "contexts/replyContext";
import EmojiPicker from "emoji-picker-react";
import moment from "moment";
import ChatModalAddContact from "pages/app/chat/ChatModalAddContact";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Badge, DropdownItem, DropdownMenu, DropdownToggle, Spinner, UncontrolledDropdown } from "reactstrap";
import { serviceMarkChatSolved, servicePutAssignChatBot } from "services/chats";
import { serviceGetChatLimit } from "services/chatLimits";
import {
  serviceGetMessages,
  serviceGetMessagesAfterCursor,
  serviceSendMessage,
  serviceSendMessageDocument,
  serviceSendMessageImage,
  serviceSendMessageVideo,
} from "services/messages";
import { serviceGetQuickReplyChat, serviceGetQuickReplyMedia } from "services/quickReply";
import SimpleBar from "simplebar-react";
import { useKeyPress } from "utils/Keypress";
import { Button, Icon, UserAvatar } from "../../../components/Component";
import getTextColor from "../../../components/custom/getTextColor";
import { delay, getPermission } from "../../../utils/Utils";
import { ChatContext } from "./ChatContext";
import ChatModalAssign from "./ChatModalAssign";
import ChatModalHandoff from "./ChatModalHandoff";
import ChatModalResolve from "./ChatModalResolve";
import ChatModalTagAssign from "./ChatModalTagAssign";
import { MeChat, QuickReplyItem, SessionResolved, YouChat } from "./ChatPartials";
import ChatSearchSidebar from "./ChatSearchSidebar";
import ChatSideBar from "./ChatSideBar";
import { getUnprocessedMessages, mergeIncomingMessage, utilNumberPhoneConvention } from "./utils/ChatUtils";
import { serviceGetTicketsById } from "services/tickets";

import Swal from "sweetalert2";

const ChatBody = ({
  cookies,
  mobileView,
  setMobileView,
  setIsModalTagAssignOpen,
  isModalTagAssignOpen,
  setCheckedTag,
  AfterAssign,
  userDetail,
}) => {
  const {
    chatListState,
    chatListIdState,
    selectedIdState,
    filteredChatListState,
  } = useContext(ChatContext);
  const [chatList, setChatList] = chatListState;
  const [selectedId, setSelectedId] = selectedIdState;
  const [filteredChatList, setFilteredChatList] = filteredChatListState;
  const [, setChatIdList] = chatListIdState;

  const downPress = useKeyPress("ArrowDown");
  const upPress = useKeyPress("ArrowUp");
  const enterPress = useKeyPress("Enter");
  const tabPress = useKeyPress("Tab");
  // const [selected, setSelected] = useState(undefined);
  const [cursor, setCursor] = useState(0);
  const [hovered, setHovered] = useState(undefined);
  const { messagesValue, statusValue } = useContext(MessagesContext);
  const [newMessages] = messagesValue;
  const [newStatusMessages] = statusValue;
  const [currentChat, setCurrentChat] = useState(null);
  const [currentTag, setCurrentTag] = useState([]);
  const [messages, setMessages] = useState([]);
  const [modalImage, setModalImage] = useState(false);
  const [modalVideo, setModalVideo] = useState(false);
  const [modalDocument, setModalDocument] = useState(false);
  const [sidebar, setsidebar] = useState(false);
  const [searchSidebar, setSearchSidebar] = useState(false);
  const [inputText, setInputText] = useState("");
  const [afterCursor, setAfterCursor] = useState("");
  const [, setIsScrollTop] = useState(false);
  const [chatOptions, setChatOptions] = useState(false);
  const [isModalAssignOpen, setIsModalAssignOpen] = useState(false);
  const [isModalAddContactOpen, setIsModalAddContactOpen] = useState(false);
  const [isModalHandoffOpen, setIsModalHandoffOpen] = useState(false);
  const [isModalResolveOpen, setIsModalResolveOpen] = useState(false);
  const [imageFile, setImageFile] = useState(null);
  const [videoFile, setVideoFile] = useState(null);
  const [documentFile, setDocumentFile] = useState(null);
  const [, setShowQuickReply] = useState(false);
  const [searchQuickReply, setSearchQuickReply] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const processedGlobalMessageCountRef = useRef(0);
  const quickReplyDebounceRef = useRef(null);
  const [isQuickReplyLoading, setIsQuickReplyLoading] = useState(false);
  const [quickReplyData, setQuickReplyData] = useState([]);
  const [quickReplyState, setQuickReplyState] = useState(false);
  const [quickReplyInput, setQuickReplyInput] = useState("");
  const emojiButonRef = useRef(null);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const messagesEndRef = useRef(null);
  const bodyChatRef = useRef(null);
  const inputChat = useRef(null);
  const inputChatMedia = useRef(null);
  const [changeChat, setChangeChat] = useState(false);

  const [isLoadingSend, setIsLoadingSend] = useState(false);
  const [chatLimit, setChatLimit] = useState(null);

  let roleFunctions = getPermission()["chats"]?.access || [];
  if (cookies.role.name !== "SALES" && cookies.role.name !== "CS") {
    roleFunctions = roleFunctions.filter((rf) => rf !== "chat");
  }

  const { value, value2 } = useContext(ReplyContext);
  const [replyMessage, setReplyMessage] = value;
  const [contextMessage, setContextMessage] = value2;
  const [isLoading, setIsLoading] = useState(true);
  const [showScrollButton, setShowScrollButton] = useState(false);
  const BOT_ID = "3ef9f486-ddad-46ed-b568-f7b32a62262f";

  // jika memilih suatu chat
  useEffect(() => {
    let dataChat = chatList.find((item) => item.id === selectedId);
    if (!dataChat) {
      dataChat = filteredChatList.find((item) => item.id === selectedId);
      if (!dataChat) {
        return;
      }
    }

    setMessages([]);
    setCurrentChat({ ...dataChat });
    setCurrentTag([...dataChat?.tags]);
    setChangeChat(true);
    refreshMessages();
    setModalImage(false);
    setModalVideo(false);
    setImageFile(null);
    setVideoFile(null);
    setDocumentFile(null);
    setReplyMessage(null);
    setSearchSidebar(false);
    // setContextMessage(null);
    setShowQuickReply(false);
    setsidebar(false);
    refreshQuickReply();
    scrollToBottom();
  }, [selectedId]);

  useEffect(() => {
    const dataChat = chatList.find((item) => item.id === selectedId);
    if (dataChat?.tags && dataChat.tags.length > -1) {
      setCurrentTag([...dataChat.tags]);
    }
  }, [chatList]);

  const refreshChatLimit = async (chatId) => {
    const response = await serviceGetChatLimit(cookies.SIDikey, chatId);
    if (response?.status === 200) setChatLimit({ ...response.data, chatId });
  };

  // kuota chat hanya relevan untuk sales yang di-assign ke room ini
  useEffect(() => {
    if (selectedId && currentChat?.userId === cookies.id) refreshChatLimit(selectedId);
  }, [selectedId, currentChat?.userId]);

  useEffect(() => {
    if (replyMessage !== null) {
      document.getElementById("real-default-textarea").focus();
    }
  }, [replyMessage]);

  const refreshMessages = async () => {
    setIsLoading(true);
    const responseGetMessages = await serviceGetMessages(cookies.SIDikey, selectedId);
    setIsLoading(false);
    if (new RegExp(/20+/).test(responseGetMessages.status)) {
      const data = responseGetMessages.data;
      const messagesData = data.data.reverse();
      const metaData = data.meta;
      if (metaData.hasNextPage) {
        setAfterCursor(metaData.afterCursor);
      }
      setMessages(messagesData);
      // await delay(500);
      scrollToBottom();
    } else {
      //console.log("error Get Messagefrom DB, chatBody", responseGetMessages);
    }
  };

  const takeOverChat = async (isTakeOver = true) => {
    const userId = isTakeOver ? cookies.id : BOT_ID;
    const resp = await servicePutAssignChatBot(cookies.SIDikey, isTakeOver, currentChat.id, userId, {
      chatId: currentChat.id,
      newUserId: userId,
    });
    console.log(resp);
    let newChat;

    if (resp && new RegExp(/20+/).test(resp?.status)) {
      Swal.fire("Berhasil", "", "success");

      newChat = resp.data;

      currentChat.user = resp.data.user;
      currentChat.userId = resp.data.user.id;

      currentChat.unreadCountCS = 1;
      currentChat.unreadCount = 1;

      if (resp.data.lastMessage) {
        const lastMessage = resp.data.lastMessage;
        newChat.lastMessage = lastMessage;
        setMessages((msgs) => [...msgs, resp.data.lastMessage]);
      }

      setCurrentChat((chat) => {
        return { ...newChat, ...chat };
      });

      if (filteredChatList && filteredChatList.length > 0) {
        setFilteredChatList((prevChatList) => {
          const currentChatIndex = prevChatList.findIndex((chat) => chat.id === newChat.id);

          if (currentChatIndex === -1) return prevChatList; // No change if chat not found

          // Create new array with current chat at top
          return [newChat, ...prevChatList.filter((_, index) => index !== currentChatIndex)];
        });
      }

      setChatList((prevChatList) => {
        const currentChatIndex = prevChatList.findIndex((chat) => chat.id === newChat.id);

        if (currentChatIndex === -1) return prevChatList; // No change if chat not found

        // Create new array with current chat at top
        return [newChat, ...prevChatList.filter((_, index) => index !== currentChatIndex)];
      });
    } else {
      Swal.fire(
        "Gagal",
        "Transaksi Berhenti di tengah-tengah mohon hard-refresh browser dan pastikan koneksi baik.",
        "error",
      );
    }
  };

  const refreshQuickReply = async () => {
    if (!isSearching) {
      return;
    }

    let query = searchQuickReply.split("/").filter(Boolean).pop();
    let getAllDepartmentIds = [];
    getAllDepartmentIds.push(currentChat.channel.departmentId);
    currentChat.tags.forEach((item) => {
      if (item.departmentId) {
        getAllDepartmentIds.push(item.departmentId);
      }
    });

    const responseGetQuickReply = await serviceGetQuickReplyChat(cookies.SIDikey, query, getAllDepartmentIds);

    if (new RegExp(/20+/).test(responseGetQuickReply.status)) {
      const data = responseGetQuickReply.data;
      const finalData = data.map((reply) => ({
        name: reply.name,
        content: reply.response,
        command: "/" + reply.command,
        media: reply.media,
      }));

      setQuickReplyData(finalData);
    } else {
      //console.log("responseGetQuickReply", responseGetQuickReply);
    }
    setIsQuickReplyLoading(false);
  };

  useEffect(() => {
    if (quickReplyDebounceRef.current) {
      clearTimeout(quickReplyDebounceRef.current);
    }

    if (isSearching) {
      setIsQuickReplyLoading(true);
    }

    quickReplyDebounceRef.current = setTimeout(() => {
      refreshQuickReply();
    }, 500);

    return () => {
      if (quickReplyDebounceRef.current) {
        clearTimeout(quickReplyDebounceRef.current);
      }
    };
  }, [searchQuickReply]);

  const addMessages = async (cursorSpec) => {
    let includeCursor = "true";
    const response = await serviceGetMessagesAfterCursor(cookies.SIDikey, selectedId, cursorSpec, includeCursor);

    if (response.status === 200) {
      const data = response.data;
      const messagesData = data.data.reverse();
      const metaData = data.meta;

      messagesData.pop(); // delete last message

      setMessages((messages) => [...messagesData, ...messages]);
      //add messasges by click

      if (metaData.hasNextPage) {
        setAfterCursor(metaData.afterCursor);
      } else {
        setAfterCursor("");
      }

      setIsScrollTop(true);
      scrollToStill(messages.at(0)?.id);
    }
    if (afterCursor !== cursorSpec) {
      await new Promise((res) => setTimeout(res, 100));
      includeCursor = "true";
    }
    return response;
  };

  const scrollToStill = (id) => {
    if (id) {
      const element = document.querySelector(`[id='${id}']`);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
        element.classList.add("highlight__animate");
        setTimeout(() => {
          element.classList.remove("highlight__animate");
        }, 2000);
      }
    }
  };
  const scrollToBottom = () => {
    if (messagesEndRef.current) {
      const scrollHeight = messagesEndRef.current.scrollHeight;
      messagesEndRef.current.scrollTop = scrollHeight + 50;
      // messagesEndRef.current.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;
    }
    // }
  };

  const onScrolling = async () => {
    if (messagesEndRef.current) {
      if ((messagesEndRef.current.scrollTop === 0) & (afterCursor !== "")) {
        // DO SOMETHING HERE if top is reached
      }
    }
  };

  const loadMoreMessages = async (e) => {
    e.preventDefault();
    if (messagesEndRef.current) {
      if (afterCursor !== "") {
        // TO SOMETHING HERE
        setIsScrollTop(true);
        const response = await addMessages(afterCursor);
        if (response.status !== 200) {
          //console.log("error add messages", response);
        }
      }
    }
  };

  // jika ada perubahan di messages
  useEffect(() => {
    if (changeChat) {
      // setIsScrollTop(false);
      setInputText("");
      setQuickReplyState(false);
      setQuickReplyInput("");
      setChangeChat(false);
      return;
    }

    if (!isAtBottom()) {
      scrollToBottom();
    }

    const message = messages.at(-1);
    if (message === undefined) {
      return;
    }

    let newChats = [];
    chatList.forEach((element) => {
      let ch = element;
      if (message.chatId === element.id) {
        if (ch?.lastMessage?.id === message?.id) {
          return;
        }
        ch.lastMessage = message;
        newChats = chatList.filter((item) => {
          return item.id !== message.chatId;
        });
        // newChats = [ch, ...newChats];
        setChatList([ch, ...newChats]);
      } else {
        // newChats.push(ch);
      }
    });
  }, [messages]);

  // contextMessage jump to context message
  useEffect(() => {
    if (contextMessage) {
      if (contextMessage.id.includes("fromSearchedMessage_")) {
        contextMessage.id.replace("fromSearchedMessage_", "");
        setTimeout(() => {}, 4000);
      }
      const element = document.querySelector(`[id='${contextMessage.id}']`);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "end" });
        element.classList.add("highlight__animate");
        setContextMessage(null);
        setTimeout(() => {
          element.classList.remove("highlight__animate");
        }, 4000);
      } else {
        addMessages(contextMessage.cursor);
        setTimeout(() => {}, 2000);
        // const element = document.querySelector(`[id='${contextMessage.id}']`);
        setContextMessage(null);
      }
    }
  }, [contextMessage]);

  useEffect(() => {
    const { toProcess, nextCount } = getUnprocessedMessages(newMessages, processedGlobalMessageCountRef.current);
    processedGlobalMessageCountRef.current = nextCount;

    const newPersonalMessages = toProcess.filter(function (msg) {
      try {
        let chatIDonMessage = null;
        if (
          msg.text &&
          msg.text.includes("Terima kasih telah memberikan penilaian Anda! Kami sangat menghargai masukan")
        ) {
          chatIDonMessage = msg?.chatId;
        } else {
          chatIDonMessage = msg?.chat?.id;
        }
        return (
          (chatIDonMessage === currentChat?.id || chatIDonMessage === currentChat?.chat?.id) &&
          msg?.type !== "status-update" &&
          msg?.type !== "tag-update" &&
          msg?.type !== "tag-update-resolve"
        );
      } catch (error) {
        //console.log("error", error);
        return false;
      }
    });

    for (const msg_raw of newPersonalMessages) {
      if (!msg_raw?.chat) {
        msg_raw.chat = currentChat;
      }
      try {
        if (msg_raw.chat && !msg_raw.chat.tags) {
          msg_raw.chat.tags = currentChat.tags;
        }
        setChangeChat(false);
        handleNewMessage(msg_raw);
      } catch (error) {
        console.error("An error occurred while processing the message:", error);
      }
    } //jika message bukan chat ini, newPersonalMessages kosong dan loop skip
  }, [newMessages]);

  const handleNewMessage = async (msg_raw) => {
    // Event tag-update bukan pesan chat — jangan dirender sebagai bubble.
    // Cukup update tags di currentChat supaya header chat body ikut sinkron.
    if (msg_raw.type === "tag-update" || msg_raw.type === "tag-update-resolve") {
      const chatId = msg_raw.chatId ?? msg_raw.chat?.id;
      if (chatId === currentChat?.id) {
        setCurrentChat((prev) => ({ ...prev, tags: msg_raw.tags }));
      }
      return;
    }

    const sameMessageIndex = messages.findIndex((msg) => msg.id === msg_raw.id);

    if (sameMessageIndex !== -1) {
      setMessages((prev) => prev.map((msg) => (msg.id === msg_raw.id ? { ...msg, status: msg_raw.status } : msg)));
      await delay(200);
      if (!isAtBottom()) scrollToBottom();

      return;
    }

    let diffTicket = false;

    // ponytail: this branch decision (new ticket vs. same ticket) still
    // reads currentChat/messages from the stale outer closure — if two
    // messages in the exact same burst both need it, the second call's
    // decision can be based on pre-burst state. Doesn't lose message
    // content (that's what mergeIncomingMessage fixes); upgrade path
    // if ticket-switch races are ever reported: move this whole handler to
    // consume a pre-drained batch instead of being invoked once per message.
    {
      let tickets = [];
      if (msg_raw.ticketId && msg_raw.ticketId !== currentChat.tickets[0].id) {
        //get new ticket
        diffTicket = true;
        if (msg_raw.type !== "tag-update" && msg_raw.type !== "tag-update-resolve") {
          setCurrentChat({ ...msg_raw.chat, tickets: [{ ...tickets[0], id: msg_raw.ticketId }] });
        }
        setMessages((prev) => mergeIncomingMessage(prev, msg_raw));
        const resNetTicket = await serviceGetTicketsById(cookies.SIDikey, msg_raw.ticketId);
        if (resNetTicket.status === 200) {
          tickets = resNetTicket.data.data;
        }
      } else {
        tickets = currentChat.tickets;
      }
      if (msg_raw.type !== "tag-update" && msg_raw.type !== "tag-update-resolve") {
        if (msg_raw.ticketId) {
          setCurrentChat({ ...msg_raw.chat, tickets: [{ ...tickets[0], id: msg_raw.ticketId }] });
        } else {
          setCurrentChat({ ...msg_raw.chat, tickets: [{ ...tickets[0] }] });
        }
      }
      setSelectedId(msg_raw.chatId);
    }

    if (!diffTicket) {
      setMessages((prev) => mergeIncomingMessage(prev, msg_raw));
    }

    await delay(200);
    if (!isAtBottom()) scrollToBottom();
  };

  // update status message
  useEffect(() => {
    const statusMessage = newStatusMessages.at(-1);
    const replaceMessages = messages;
    for (let index = replaceMessages.length - 1; index >= 0; index--) {
      if (replaceMessages[index]?.id === statusMessage?.id) {
        // setMessages(replaceMessages);
        replaceMessages[index] = statusMessage;
        setMessages([...replaceMessages]);

        let newChats = chatList;
        for (let index = 0; index < newChats.length; index++) {
          const element = newChats[index];
          if (element.lastMessage.id === statusMessage.id) {
            newChats[index].lastMessage = statusMessage;
            setChatList([...newChats]);
            break;
          }
        }
        return;
      }
    }
  }, [newStatusMessages]);

  const onChatOptions = () => {
    setChatOptions(!chatOptions);
  };

  const onInputChange = (e) => {
    const value = e.target.value;
    setInputText(value);

    if (!value.includes("/")) {
      setQuickReplyState(false);
      setQuickReplyInput("");
      setIsQuickReplyLoading(false);
      setIsSearching(false);
      setSearchQuickReply("");
      if (quickReplyDebounceRef.current) {
        clearTimeout(quickReplyDebounceRef.current);
      }
    } else {
      const query = value.split("/").filter(Boolean).pop() || "";
      setIsSearching(true);
      setSearchQuickReply("/" + query);
      setQuickReplyInput(value);
    }
  };

  const closeSearchBar = () => {
    setSearchSidebar(false);
  };

  const toggleMenu = () => {
    setsidebar(!sidebar);
    if (searchSidebar) {
      setSearchSidebar(false);
    }
  };

  const toggleSearch = () => {
    setSearchSidebar(!searchSidebar);
    if (sidebar) {
      setsidebar(false);
    }
  };

  const jumpReply = async (e) => {
    e.preventDefault();
  };

  const quickReplySelect = async (quickReply) => {
    let Input = inputText;
    const newInput = Input.replace(searchQuickReply, quickReply.content);
    setInputText(newInput);
    setQuickReplyState(false);
    setSearchQuickReply("");
    setQuickReplyInput("");
    document.getElementById("real-default-textarea").focus();

    if (quickReply.media) {
      const mediaFile = await serviceGetQuickReplyMedia(quickReply.media, quickReply.name);
      if (!mediaFile) return;

      setImageInput(mediaFile);
    }
  };

  const onTextSubmit = async (e) => {
    // Prevent multiple submissions
    if (isLoadingSend) {
      return;
    }
    setIsLoadingSend(true);
    e.preventDefault();
    let text = inputText.replace("%0A", "\r\n");
    let msg = isSearching
      ? {
          text: text,
          type: "TEXT",
          chatId: selectedId,
        }
      : {
          text: text,
          type: "TEXT",
          chatId: selectedId,
        };
    msg["wa_id"] = currentChat.customerPhone;
    msg["ticketId"] = currentChat.tickets[0].id;
    if (replyMessage) {
      msg["contextId"] = replyMessage?.id;
    }

    if (imageFile) {
      if (imageFile.size > 64 * 1024 * 1024) {
        Swal.fire({
          icon: "error",
          title: "Picture too large",
          text: "Ukuran Gambar tidak boleh melebihi 64 MB",
          focusConfirm: false,
        });
        return;
      }
      if (imageFile.type.includes("image")) {
        msg.type = "IMAGE";
        const response = await serviceSendMessageImage(cookies.SIDikey, msg, imageFile);
        msg = response.data;
        setImageFile(null);
      } else {
        Swal.fire({
          icon: "error",
          title: "File unsupported",
          text: "Mohon gunakan gambar dengan format png/jpeg/jpg ",
          focusConfirm: false,
        });
        return;
      }
    } else if (documentFile) {
      if (documentFile.size > 64 * 1024 * 1024) {
        Swal.fire({
          icon: "error",
          title: "File too large",
          text: "Ukuran file tidak boleh melebihi 64 MB",
          focusConfirm: false,
        });
        return;
      }
      msg.type = "DOCUMENT";
      msg.text = "";

      const response = await serviceSendMessageDocument(cookies.SIDikey, msg, documentFile);
      msg = response.data;
      setDocumentFile(null);
    } else if (videoFile) {
      if (videoFile.size > 64 * 1024 * 1024) {
        Swal.fire({
          icon: "error",
          title: "Video too large",
          text: "Ukuran Video tidak boleh melebihi 64 MB",
          focusConfirm: false,
        });
        return;
      }
      if (videoFile.type.includes("video")) {
        msg.type = "VIDEO";
        const response = await serviceSendMessageVideo(cookies.SIDikey, msg, videoFile);
        msg = response.data;
        setVideoFile(null);
      } else {
        Swal.fire({
          icon: "error",
          title: "File unsupported",
          text: "Mohon gunakan video dengan format mp4, 3gpp ",
          focusConfirm: false,
        });
        return;
      }
    } else {
      if (inputText === "") {
        setIsLoadingSend(false);
        return;
      }
      msg.type = "TEXT";
      const response = await serviceSendMessage(cookies.SIDikey, msg);
      msg = response.data;
      msg["fromMe"] = true;
    }
    if (replyMessage) {
      msg["context"] = replyMessage;
    }

    setMessages((messages) => [...messages, msg]);
    msg.sumber = "FE";
    msg.status = "SENT";
    // socketIO.emit("admin", JSON.stringify(msg));

    setInputText("");
    setReplyMessage(null);
    setModalImage(false);
    setModalDocument(false);
    setModalVideo(false);
    setIsScrollTop(false);
    setIsSearching(false);

    setIsLoadingSend(false);
    refreshChatLimit(selectedId);
  };

  // chatId check drops stale responses from a previously selected room
  const showChatLimit = chatLimit?.chatId === selectedId && chatLimit.quota != null;
  const chatLimitTitle = showChatLimit
    ? chatLimit.overQuota > 0
      ? `Over kuota ${chatLimit.overQuota} pesan (kuota ${chatLimit.quota}, terkirim ${chatLimit.used})`
      : `Sisa kuota ${chatLimit.remaining} dari ${chatLimit.quota} pesan`
    : undefined;

  const chatBodyClass = classNames({
    "nk-chat-body position-relative": true,
    "show-chat": mobileView,
    "profile-shown": (sidebar && window.innerWidth > 1550) || (searchSidebar && window.innerWidth > 1550),
    // "chat-body-shrink": searchSidebar,
  });

  const setImageInput = (file) => {
    setImageFile(file);
    setChatOptions(!chatOptions);
    setModalImage(true);
    setModalDocument(false);
    setModalVideo(false);
  };

  const setVideoInput = (file) => {
    setVideoFile(file);
    setChatOptions(!chatOptions);
    setModalVideo(true);
    setModalDocument(false);
    setModalImage(false);
  };

  const setDocumentInput = (file) => {
    setDocumentFile(file);
    setChatOptions(!chatOptions);
    setModalDocument(true);
    setModalImage(false);
    setModalVideo(false);
  };

  const handleImageFileChange = (e) => {
    if (e.target.files) {
      setImageInput(e.target.files[0]);
      e.target.value = null;
    }
  };

  const handleVideoFileChange = (e) => {
    if (e.target.files) {
      setVideoInput(e.target.files[0]);
      e.target.value = null;
    }
  };

  const handleDocumentFileChange = (e) => {
    if (e.target.files) {
      setDocumentInput(e.target.files[0]);
      e.target.value = null;
    }
  };

  const convertFileSize = (size) => {
    if (size === 0) {
      return "0 Bytes";
    }
    const k = 1000;
    const decimal = 2;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const index = Math.floor(Math.log(size) / Math.log(k));

    return parseFloat((size / Math.pow(k, index)).toFixed(decimal)) + " " + sizes[index];
  };

  const handleUploadDocumentClick = () => {
    document.getElementById("selectDocument").click();
    if (documentFile) {
      setDocumentFile(null);
    }
  };

  const handleUploadImageClick = () => {
    document.getElementById("selectImage").click();
    if (imageFile) {
      setImageFile(null);
    }
  };

  const handleUploadVideoClick = () => {
    document.getElementById("selectVideo").click();
    if (videoFile) {
      setVideoFile(null);
    }
  };

  const onKeyDownHandler = (e) => {
    console.log("onKeyDownHandler e", quickReplyState, e.code);
    if (!quickReplyState) {
      if ((e.code === "Enter" && !e.shiftKey) || e.code === "NumpadEnter") {
        if (!isLoadingSend && (inputText !== "" || imageFile || documentFile || videoFile)) {
          onTextSubmit(e);
        }
      }
      if (quickReplyState) {
        if (e.code === "Slash" || e.code === "Space") {
          setQuickReplyState(false);
          setQuickReplyInput("");
        } else {
          if (e.keyCode >= 65 && e.keyCode <= 90) {
            const query = quickReplyInput + e.key;
            setQuickReplyInput(query);
          }
          if (e.code === "Backspace") {
            const query = quickReplyInput.slice(0, -1);
            setQuickReplyInput(query);
          }
        }
      } else {
        if (e.code === "Slash") {
          setQuickReplyState(true);
        }
      }
    }
  };
  const dateCheck = (input) => {
    return new Date(Number(input)).toLocaleString("en-GB", {
      month: "numeric",
      year: "numeric",
      day: "numeric",
    });
  };

  const dateProcessing = (timestamp) => {
    const today = moment().format("DD/MM/YYYY");
    const compared = moment.unix(timestamp / 1000).format("DD/MM/YYYY");

    if (today === compared) {
      return "Today";
    } else if (moment().subtract(1, "day").format("DD/MM/YYYY") === compared) {
      return "Yesterday";
    }
    return new Date(Number(timestamp)).toLocaleString("en-GB", {
      month: "numeric",
      year: "numeric",
      day: "numeric",
    });
  };

  const addEmoji = (data) => {
    setInputText(inputText + data.emoji);
    emojiButonRef?.current?.click();
    document.getElementById("real-default-textarea").focus();
  };

  useEffect(() => {
    if (quickReplyState && quickReplyData.length && downPress) {
      document.getElementById("real-default-textarea").blur();
      setCursor((prevState) => (prevState < quickReplyData.length - 1 ? prevState + 1 : prevState));
    }
  }, [downPress, quickReplyData.length, quickReplyState]);
  useEffect(() => {
    if (quickReplyState && quickReplyData.length && upPress) {
      document.getElementById("real-default-textarea").blur();
      setCursor((prevState) => (prevState > 0 ? prevState - 1 : prevState));
    }
  }, [quickReplyData.length, quickReplyState, upPress]);
  useEffect(() => {
    if (quickReplyState && quickReplyData.length && enterPress) {
      // const foundItem = quickReplyData.find((item) => item.command.toLowerCase().includes(searchQuickReply));
      const foundItem = quickReplyData.find((item) => item.command.includes(searchQuickReply));
      if (searchQuickReply) {
        // setSelected(quickReplyData[cursor]);
        quickReplySelect(quickReplyData[cursor]);
      } else {
        // setSelected(foundItem);
        quickReplySelect(foundItem);
      }
    } else if (quickReplyState && quickReplyData.length && tabPress) {
      // const foundItem = quickReplyData.find((item) => item.command.toLowerCase().includes(searchQuickReply));
      const foundItem = quickReplyData.find((item) => item.command.includes(searchQuickReply));
      if (searchQuickReply) {
        // setSelected(quickReplyData[cursor]);
        quickReplySelect(quickReplyData[cursor]);
      } else {
        // setSelected(foundItem);
        quickReplySelect(foundItem);
      }
    }
  }, [cursor, enterPress, quickReplyData, quickReplySelect, quickReplyState]);
  const isAtBottom = () => {
    if (messagesEndRef.current !== null) {
      const { scrollTop, scrollHeight, clientHeight } = messagesEndRef?.current;
      return Math.round(scrollTop + clientHeight) < scrollHeight;
    } else {
      return;
    }
  };

  const handleScroll = () => {
    setShowScrollButton(isAtBottom());
  };
  useEffect(() => {
    if (quickReplyState && quickReplyData.length && hovered) {
      setCursor(quickReplyData.indexOf(hovered));
    }
  }, [hovered, quickReplyData, quickReplyState]);

  useEffect(() => {
    setShowScrollButton(isAtBottom());
    messagesEndRef?.current?.addEventListener("scroll", handleScroll);
    return () => {
      messagesEndRef?.current?.removeEventListener("scroll", handleScroll);
    };
  }, [showScrollButton]);

  // Button for show resolve popup
  const ResolveButton = () => {
    if (!roleFunctions.includes("chat") || currentChat.status === "PENDING" || currentChat.status === "RESOLVED")
      return "History";
    return "Resolve";
  };

  const canMarkChatSolved =
    (cookies.role.name === "SALES" || cookies.role.name === "CS") &&
    currentChat &&
    !["RESOLVED", "PENDING", "SOLVED"].includes(currentChat.status);

  const handleMarkChatSolved = async () => {
    const resp = await serviceMarkChatSolved(cookies.SIDikey, currentChat.id);

    if (resp.status !== 202) {
      Swal.fire("Gagal menandai SOLVED", "Mohon coba lagi", "error");
      return;
    }

    const solvedFields = {
      status: "SOLVED",
      adminStatus: "SOLVED",
      csStatus: "SOLVED",
      superStatus: "SOLVED",
      headStatus: "SOLVED",
      auditorStatus: "SOLVED",
      sysAdminStatus: "SOLVED",
    };

    setCurrentChat({ ...currentChat, ...solvedFields });
    Swal.fire("Berhasil", "Chat ditandai SOLVED", "success");
    AfterAssign();
  };

  const handlePaste = async (e) => {
    e.preventDefault(); // Prevent default paste behavior
    const clipboardData = e.clipboardData || window.clipboardData;

    // Check if clipboard contains files first
    if (clipboardData.files && clipboardData.files.length > 0) {
      const file = clipboardData.files[0];
      const fileType = file.type;

      if (fileType.startsWith("image/")) {
        setImageInput(file);
      } else if (fileType.startsWith("video/")) {
        setVideoInput(file);
      } else {
        setDocumentInput(file);
      }
      setChatOptions(false);
    } else {
      // Handle text paste
      const pastedText = clipboardData.getData("text");
      if (pastedText) {
        // Get current cursor position
        const textarea = e.target;
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;
        const currentText = textarea.value;

        // Insert pasted text at cursor position
        const newText = currentText.substring(0, start) + pastedText + currentText.substring(end);
        setInputText(newText);

        // Set cursor position after pasted text
        setTimeout(() => {
          textarea.selectionStart = textarea.selectionEnd = start + pastedText.length;
        }, 0);
      }
    }
  };

  return (
    <React.Fragment>
      {currentChat && Object.keys(currentChat).length > 0 && (
        <div className={chatBodyClass}>
          <div className="nk-chat-head" ref={bodyChatRef}>
            <div
              className="chat-head-button"
              onClick={(e) => {
                e.preventDefault();
                toggleMenu();
              }}
            />
            <ul className="nk-chat-head-info">
              <li className="nk-chat-body-close" onClick={() => setMobileView(false)}>
                <a
                  href="#hide-chat"
                  onClick={(ev) => {
                    ev.preventDefault();
                  }}
                  className="btn btn-icon btn-trigger nk-chat-hide ml-n1"
                >
                  <Icon name="arrow-left"></Icon>
                </a>
              </li>
              <li className="nk-chat-head-user">
                <div className="user-card">
                  <UserAvatar
                    image={currentChat.image}
                    icon="user-alt-fill"
                    theme={currentChat.theme}
                    className="overflow-hidden"
                  ></UserAvatar>
                  <div className="user-info">
                    <div className="lead-text">
                      {utilNumberPhoneConvention(currentChat?.name ?? currentChat?.customerPhone)}
                    </div>
                    {currentTag?.map((item, idx) => {
                      return (
                        <span
                          key={idx}
                          className="badge rounded-pill text-bg-primary"
                          style={{
                            background: item.color,
                            borderColor: "#050505",
                            color: getTextColor(item.color),
                            margin: "2px",
                          }}
                        >
                          {item.name}
                        </span>
                      );
                    })}
                    {currentChat.tickets && currentChat.tickets[0]?.campaign && (
                      <span
                        className="badge rounded-pill text-bg-primary"
                        style={{ background: "#f7f5f5", color: "#050505", margin: "2px" }}
                      >
                        {currentChat.tickets[0]?.campaign.name}
                      </span>
                    )}
                  </div>
                </div>
              </li>
            </ul>
            <ul className="nk-chat-head-tools info-chat-head">
              {showChatLimit && (
                <li className="mr-1 mr-md-1" title={chatLimitTitle}>
                  <Badge pill color="danger" className="d-inline-flex align-items-center" style={{ fontSize: 13 }}>
                    <Icon name="alert-circle-fill" className="mr-1"></Icon>
                    Kuota: {chatLimit.overQuota > 0 ? -chatLimit.overQuota : chatLimit.remaining} pesan
                  </Badge>
                </li>
              )}
              {currentChat.userId !== BOT_ID && roleFunctions.includes("Take_Over_Chatbot") && (
                <li className="mr-1 mr-md-1">
                  <Button color="info" className="btn-round" size="xs" onClick={(e) => takeOverChat(false)}>
                    ASSIGN TO BOT
                  </Button>
                </li>
              )}
              {currentChat.userId === BOT_ID && roleFunctions.includes("Take_Over_Chatbot") && (
                <li className="mr-1 mr-md-1">
                  <Button color="warning" className="btn-round" size="xs" onClick={(e) => takeOverChat(true)}>
                    Take Over
                  </Button>
                </li>
              )}
              <li>
                <a
                  href="#search"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleSearch();
                  }}
                  className="btn btn-icon btn-trigger text-primary chat-profile-toggle"
                >
                  <Icon name="search"></Icon>
                </a>
              </li>
              <li>
                <a
                  href="#add"
                  onClick={(e) => {
                    e.preventDefault();
                    setsidebar(false);
                  }}
                  className="btn btn-icon btn-trigger text-primary chat-profile-toggle"
                >
                  <Icon name="user-add-fill" onClick={() => setIsModalAddContactOpen(true)} />
                </a>
                {isModalAddContactOpen ? (
                  <ChatModalAddContact
                    cookies={cookies}
                    chatData={currentChat}
                    setChatData={setCurrentChat}
                    modalDetail={isModalAddContactOpen}
                    modalToggle={() => setIsModalAddContactOpen(false)}
                    AfterAssign={AfterAssign}
                    userDetal={userDetail}
                  />
                ) : null}
              </li>
              {roleFunctions.includes("assign") && (
                <li className="d-none d-sm-block">
                  <UncontrolledDropdown>
                    <DropdownToggle
                      tag="a"
                      className="dropdown-toggle btn btn-icon btn-trigger text-primary"
                      onClick={() => {
                        if (!roleFunctions.includes("assign") || currentChat.status === "RESOLVED") {
                          return;
                        } else {
                          if (currentChat.userId === BOT_ID) {
                            Swal.fire("Forbidden", "Chat masih dalam bot session, Take over terlebih dahulu.", "error");
                          } else {
                            setIsModalAssignOpen(true);
                          }
                        }
                      }}
                    >
                      <Icon name="emails"></Icon>
                    </DropdownToggle>
                  </UncontrolledDropdown>

                  <ChatModalAssign
                    chatId={selectedId}
                    lastMessages={messages}
                    setMessages={setMessages}
                    isModalAssignOpen={isModalAssignOpen}
                    setIsModalAssignOpen={setIsModalAssignOpen}
                    cookies={cookies}
                    chat={currentChat}
                    setChat={setCurrentChat}
                    AfterAssign={() => AfterAssign()}
                    setSelectedId={setSelectedId}
                    userDetail={userDetail}
                  />
                </li>
              )}
              <li>
                <a
                  href="#tag"
                  onClick={(e) => {
                    e.preventDefault();
                    setChatIdList([currentChat.id]);
                    setIsModalTagAssignOpen(true);
                  }}
                  className="btn btn-icon btn-trigger text-primary"
                >
                  <Icon name="hash"></Icon>
                </a>
              </li>

              <ChatDetailContext.Provider value={[currentChat, setCurrentChat]}>
                <ChatModalResolve
                  cookies={cookies}
                  chat={currentChat}
                  setChat={setCurrentChat}
                  messages={messages}
                  setMessages={setMessages}
                  isModalResolveOpen={isModalResolveOpen}
                  setIsModalResolveOpen={setIsModalResolveOpen}
                  AfterAssign={AfterAssign}
                  roleFunctions={roleFunctions}
                />
              </ChatDetailContext.Provider>
              <li className="mr-n1 mr-md-n2">
                <UncontrolledDropdown>
                  <DropdownToggle tag="a" href="#more" className="btn btn-icon btn-trigger text-primary">
                    <Icon name="more-v"></Icon>
                  </DropdownToggle>
                  <DropdownMenu right>
                    <ul className="link-list-opt no-bdr">
                      {currentChat?.status !== "SOLVED" && (
                        <li>
                          <DropdownItem
                            tag="a"
                            href="#resolve"
                            onClick={(ev) => {
                              ev.preventDefault();
                              setIsModalResolveOpen(true);
                            }}
                          >
                            <Icon name="check-circle"></Icon>
                            <span>
                              <ResolveButton />
                            </span>
                          </DropdownItem>
                        </li>
                      )}
                      {canMarkChatSolved && (
                        <li>
                          <DropdownItem
                            tag="a"
                            href="#solved"
                            onClick={(ev) => {
                              ev.preventDefault();
                              handleMarkChatSolved();
                            }}
                          >
                            <Icon name="check-round-cut"></Icon>
                            <span>Mark as SOLVED</span>
                          </DropdownItem>
                        </li>
                      )}
                      {roleFunctions.includes("chat") && cookies.id === currentChat.userId && (
                        <li>
                          <DropdownItem
                            tag="a"
                            href="#handoff"
                            onClick={(ev) => {
                              ev.preventDefault();
                              setIsModalHandoffOpen(true);
                            }}
                          >
                            <Icon name="chat-circle"></Icon>
                            <span>Pindahkan ke Live Chat</span>
                          </DropdownItem>
                        </li>
                      )}
                      <li>
                        <DropdownItem
                          tag="a"
                          href={`https://wa.me/${currentChat.customerPhone}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <Icon name="whatsapp"></Icon>
                          <span>Open WA</span>
                        </DropdownItem>
                      </li>
                    </ul>
                  </DropdownMenu>
                </UncontrolledDropdown>
                <ChatModalHandoff
                  isOpen={isModalHandoffOpen}
                  setIsOpen={setIsModalHandoffOpen}
                  token={cookies.SIDikey}
                  chatId={currentChat.id}
                  onLink={(text) => {
                    setInputText(text);
                    inputChat.current?.focus();
                  }}
                />
              </li>
            </ul>
          </div>
          <div>
            <div
              className={!modalImage && !modalDocument && !modalVideo ? "d-none" : "send-image"}
              style={{
                width: bodyChatRef.current ? bodyChatRef.current.offsetWidth : "auto",
              }}
            >
              <div className="send-image-content">
                <a
                  href="#cancel"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setModalImage(false);
                    setModalDocument(false);
                    setModalVideo(false);
                    setImageFile(null);
                    setDocumentFile(null);
                    setVideoFile(null);
                  }}
                  className="send-image-close text-soft"
                >
                  <Icon name="cross-sm"></Icon>
                </a>
                <section style={{ height: "75%" }} className={!modalImage ? "d-none" : ""}>
                  <div className="d-flex justify-content-center p-4 h-100">
                    <img
                      alt="avatar"
                      className="rounded"
                      style={{ height: "100%" }}
                      src={imageFile != null ? URL.createObjectURL(imageFile) : ""}
                    />
                  </div>
                </section>
                <section style={{ height: "75%" }} className={!modalDocument ? "d-none" : ""}>
                  <div className="d-flex justify-content-center p-4 h-100">
                    <div className="mt-5 text-center">
                      <Icon name="file-fill" className="file-thumbnail" />
                      <div className="mt-2 file-name">{documentFile != null ? documentFile.name : ""}</div>
                      <div className="file-info">
                        {documentFile != null
                          ? convertFileSize(documentFile.size) + " - " + documentFile.type.toUpperCase()
                          : ""}
                      </div>
                    </div>
                  </div>
                </section>
                <section style={{ height: "70%" }} className={!modalVideo ? "d-none" : ""}>
                  <div className="d-flex justify-content-center p-4 h-100">
                    <video preload="auto" controls style={{ height: "100%" }}>
                      <source src={videoFile != null ? URL.createObjectURL(videoFile) : ""} />
                    </video>
                  </div>
                </section>
                <div className="border-top d-flex align-item-center">
                  <div className="nk-chat-editor w-100">
                    <div className="nk-chat-editor-form">
                      <div className="form-control-wrap">
                        <textarea
                          id="default-textarea"
                          readOnly={isLoadingSend}
                          style={modalDocument ? { backgroundColor: "white" } : { whiteSpace: "pre-line" }}
                          className="form-control form-control-simple no-resize"
                          rows={inputText.split("\n").length > 5 ? 5 : inputText.split("\n").length}
                          onChange={modalDocument ? null : (e) => onInputChange(e)}
                          value={modalDocument ? "" : inputText}
                          ref={inputChatMedia}
                          placeholder={modalDocument ? "" : "Type your message..."}
                          onKeyDown={(e) => {
                            onKeyDownHandler(e);
                          }}
                          disabled={modalDocument ? true : false}
                        ></textarea>
                      </div>
                    </div>
                    <ul className="nk-chat-editor-tools g-2">
                      {/* <li>
                        <Button size="sm" className="btn-icon btn-trigger text-primary">
                          <Icon name="happyf-fill"></Icon>
                        </Button>
                      </li> */}
                      {/* <li>
                        <Button size="sm" className="btn-icon btn-trigger text-primary">
                          <Icon name="menu"></Icon>
                        </Button>
                      </li> */}
                      <li>
                        <Button
                          color="primary"
                          onClick={(e) => onTextSubmit(e)}
                          className="btn-round btn-icon"
                          disabled={isLoadingSend}
                        >
                          {!isLoadingSend ? <Icon size="xl" name="send-alt"></Icon> : <Spinner size="sm"></Spinner>}
                        </Button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <SimpleBar
            className="nk-chat-panel"
            style={{ overflowAnchor: "none" }}
            onScroll={onScrolling}
            scrollableNodeProps={{ ref: messagesEndRef, onScroll: onScrolling }}
          >
            {isLoading ? (
              <>Loading</>
            ) : (
              <>
                {afterCursor ? (
                  <div className="d-flex justify-content-center">
                    <Button outline color="light" size="sm" onClick={(e) => loadMoreMessages(e)}>
                      <span>Load More Messages</span>
                      <Icon name="reload-alt" />
                    </Button>
                  </div>
                ) : (
                  <div className="d-flex justify-content-center">
                    <Button outline color="danger" size="sm" disabled>
                      <span>The End Of Chat</span>
                      <Icon name="na" />
                    </Button>
                  </div>
                )}
                {messages &&
                  messages.map((item, idx) => {
                    <React.Fragment key={idx}></React.Fragment>;
                    if (item !== undefined) {
                      if (dateCheck(Number(messages[idx - 1]?.timestamp)) === dateCheck(Number(item.timestamp))) {
                        if (item.type === "PURCHASE") {
                          const prevMessage = messages[idx - 1].text.split("pada");
                          const curMessage = item?.text.split("pada");
                          if (item?.text?.includes("ASSIGN") && prevMessage[0] === curMessage[0] && idx !== 0) {
                            return false;
                          } else {
                            return <SessionResolved key={item.id} item={item} />;
                          }
                        } else {
                          if (item.fromMe || item.fromBot) {
                            return (
                              <MeChat
                                cookies={cookies}
                                key={item.id}
                                item={item}
                                chat={currentChat}
                                contextMessage={contextMessage}
                                setReplyMessage={setReplyMessage}
                                setContextMessage={setContextMessage}
                                onClick={(e) => jumpReply(e)}
                                roleFunctions={roleFunctions}
                              ></MeChat>
                            );
                          } else {
                            return (
                              <YouChat
                                cookies={cookies}
                                id={item.id}
                                key={item.id}
                                item={item}
                                chat={currentChat}
                                setReplyMessage={setReplyMessage}
                                setContextMessage={setContextMessage}
                                onClick={(e) => jumpReply(e)}
                                roleFunctions={roleFunctions}
                              ></YouChat>
                            );
                          }
                        }
                      } else {
                        if (item.type === "PURCHASE") {
                          return <SessionResolved key={item.id} item={item} />;
                        } else {
                          if (item && (item.fromMe || item.fromBot) && item?.timestamp) {
                            return (
                              <React.Fragment key={item.id}>
                                <div className="time-separator">{dateProcessing(item.timestamp)}</div>
                                <MeChat
                                  item={item}
                                  chat={currentChat}
                                  setReplyMessage={setReplyMessage}
                                  setContextMessage={setContextMessage}
                                  onClick={(e) => jumpReply(e)}
                                  roleFunctions={roleFunctions}
                                ></MeChat>
                              </React.Fragment>
                            );
                          } else if (item && item?.timestamp && item.fromMe === false) {
                            return (
                              <React.Fragment key={item.id}>
                                <div className="time-separator">{dateProcessing(item.timestamp)}</div>
                                <YouChat
                                  setReplyMessage={setReplyMessage}
                                  setContextMessage={setContextMessage}
                                  id={item.id}
                                  item={item}
                                  chat={currentChat}
                                  onClick={(e) => jumpReply(e)}
                                  roleFunctions={roleFunctions}
                                ></YouChat>
                              </React.Fragment>
                            );
                          }
                        }
                      }
                    }
                    return <React.Fragment key={idx}></React.Fragment>;
                  })}
              </>
            )}
          </SimpleBar>

          {showScrollButton && (
            <div
              style={{
                width: "max-content",
                position: "absolute",
                bottom: "10px",
                right: "10px",
                backgroundColor: "#fff",
                borderRadius: "100%",
              }}
            >
              <Button size="lg" className={`btn-icon btn-trigger text-primary`} onClick={() => scrollToBottom()}>
                <Icon name="chevron-down"></Icon>
              </Button>
            </div>
          )}
          {quickReplyState ? (
            <div className="quick-reply-content">
              {isQuickReplyLoading ? (
                <div className="d-flex justify-content-center align-items-center p-3">
                  <Spinner size="sm" color="primary" />
                </div>
              ) : quickReplyData.length ? (
                quickReplyData.map((quickReply, idx) => {
                  return (
                    <QuickReplyItem
                      active={cursor === idx}
                      mouseEnterEvent={() => setHovered(quickReply)}
                      mouseLeaveEvent={() => setHovered(undefined)}
                      key={idx}
                      command={quickReply.command}
                      content={quickReply.content}
                      clickEvent={() => {
                        quickReplySelect(quickReply);
                        // setSelected(quickReply);
                      }}
                    />
                  );
                })
              ) : (
                <p>No quick reply data found!</p>
              )}
            </div>
          ) : null}
          {replyMessage ? (
            <div className="input-reply border-bottom">
              <div className="input-reply-content">
                <div className="input-reply-title">
                  {replyMessage.fromMe || replyMessage.fromBot ? (
                    <span>Anda : </span>
                  ) : (
                    <span>{currentChat.name} : </span>
                  )}
                </div>
                <div className="">{replyMessage.text}</div>
              </div>
              <ul className="input-reply-close">
                <Button size="lg" onClick={(e) => setReplyMessage(null)}>
                  <Icon name="cross" />
                </Button>
              </ul>
            </div>
          ) : (
            <></>
          )}

          {/* DISABLE CHAT CONDITION */}
          {roleFunctions.includes("chat") &&
          cookies.id === currentChat.userId &&
          currentChat.status !== "RESOLVED" &&
          currentChat.status !== "PENDING" &&
          currentChat.status !== "SOLVED" ? (
            <div className="nk-chat-editor">
              <div className="nk-chat-editor-upload  ml-n1">
                <div className={`chat-upload-option ${chatOptions ? "expanded" : ""}`}>
                  <ul className="">
                    <li>
                      <a
                        href="#img"
                        onClick={(ev) => {
                          ev.preventDefault();
                        }}
                      >
                        <Icon name="img-fill" onClick={handleUploadImageClick}></Icon>
                      </a>
                      <input id="selectImage" hidden type="file" accept="image/*" onChange={handleImageFileChange} />
                    </li>
                    <li>
                      <a
                        href="#file"
                        onClick={(ev) => {
                          ev.preventDefault();
                        }}
                      >
                        <Icon name="file-fill" onClick={handleUploadDocumentClick}></Icon>
                      </a>
                      <input id="selectDocument" hidden type="file" onChange={handleDocumentFileChange} />
                    </li>
                    <li>
                      <a
                        href="#video"
                        onClick={(ev) => {
                          ev.preventDefault();
                        }}
                      >
                        <Icon name="video-fill" onClick={handleUploadVideoClick}></Icon>
                      </a>
                      <input id="selectVideo" hidden type="file" accept="video/*" onChange={handleVideoFileChange} />
                    </li>
                  </ul>
                </div>
                <Button
                  size="sm"
                  className={`btn-icon btn-trigger text-primary toggle-opt ${chatOptions ? "active" : ""}`}
                  onClick={() => onChatOptions()}
                >
                  <Icon name="plus-circle-fill"></Icon>
                </Button>

                <Button
                  size="sm"
                  className={classNames(showEmojiPicker ? "d-flex" : "d-none", "btn-icon btn-trigger text-primary ")}
                  onClick={() => setShowEmojiPicker(false)}
                >
                  <Icon name="cross"></Icon>
                </Button>

                <Button
                  className="btn-icon btn-trigger text-primary toggle-opt"
                  onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                >
                  <Icon name="happyf-fill"></Icon>
                </Button>

                {showEmojiPicker && (
                  <div className="emoji-picker">
                    <EmojiPicker emojiStyle="google" onEmojiClick={addEmoji} />
                  </div>
                )}
              </div>
              <div
                className={`nk-chat-editor-form ${chatOptions ? "ml-5rem" : ""}`}
                style={{ marginLeft: chatOptions ? "120px" : "" }}
              >
                <div className="form-control-wrap">
                  <textarea
                    readOnly={isLoadingSend}
                    onPaste={handlePaste}
                    style={{ whiteSpace: "pre-line" }}
                    className="form-control form-control-simple no-resize"
                    rows={inputText.split("\n").length > 10 ? 10 : inputText.split("\n").length}
                    id="real-default-textarea"
                    onChange={(e) => onInputChange(e)}
                    value={inputText}
                    ref={inputChat}
                    placeholder="Type your messages..."
                    onKeyDown={(e) => {
                      onKeyDownHandler(e);
                    }}
                  ></textarea>
                </div>
              </div>
              <ul className="nk-chat-editor-tools g-2">
                <li>
                  <Button
                    color="primary"
                    onClick={(e) => onTextSubmit(e)}
                    className="btn-round btn-icon"
                    disabled={isLoadingSend}
                  >
                    {!isLoadingSend ? <Icon size="xl" name="send-alt"></Icon> : <Spinner size="sm"></Spinner>}
                  </Button>
                </li>
              </ul>
            </div>
          ) : (
            <></>
          )}
          <ChatSearchSidebar searchSidebar={searchSidebar} close={closeSearchBar} messages={messages} />
          <ChatSideBar sidebar={sidebar} setsidebar={setsidebar} chat={currentChat} cookies={cookies} />
          {window.innerWidth < 1550 && sidebar && (
            <div onClick={() => toggleMenu()} className="nk-chat-profile-overlay" />
          )}

          <ChatModalTagAssign
            cookies={cookies}
            isModalTagAssignOpen={isModalTagAssignOpen}
            setIsModalTagAssignOpen={setIsModalTagAssignOpen}
            checkedTag={currentChat.tags}
            setCheckedTag={setCheckedTag}
            currentChat={currentChat}
            setCurrentChat={setCurrentChat}
            setCurrentTag={setCurrentTag}
          />
        </div>
      )}
    </React.Fragment>
  );
};

export default ChatBody;
